import { render, staticRenderFns } from "./CustomerSearchResults.vue?vue&type=template&id=48f280b1&"
import script from "./CustomerSearchResults.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearchResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports